<template>
  <div class="app-container">
    <BjDivider>{{ $t('personal.title') }}</BjDivider>
    <div class="top ml0">
      <div class="picture">
        <BjKeyImage class="avatar" :url="avatar || $getPublicImage('logo-circle.png')" fit="cover" />
        <BjUpload ref="upload" class="upload mt20" auto-upload accept="image/png,image/jpeg" :accept-list="['image/jpeg', 'image/png']" :limit-size="100" @afterUpload="afterUpload">
          <el-button plain>{{ $t('personal.avatarSetting') }}</el-button>
        </BjUpload>
      </div>
      <div class="form">
        <div class="form-item">
          <span class="form-label">{{ $t('personal.loginName') }}：</span>
          <div>{{ userInfo.loginName }}</div>
        </div>
        <div class="form-item">
          <span class="form-label">{{ $t('personal.name') }}：</span>
          <div>
            <div v-show="!show">
              {{ name }}
              <i class="el-icon-edit ml0" @click="showInput(name)" />
            </div>
            <div v-show="show">
              <BjInput v-model="editName" :maxlength="MAX_LENGTH.DEFAULT" class="input" clearable />
              <span class="m20" @click="saveName">{{ $t('saveText') }}</span>
              <span class="m20" @click="concalName">{{ $t('cancelText') }}</span>
            </div>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label">{{ $t('personal.tenant') }}：</span>
          <div>{{ $store.getters.userInfo.tenantName }}</div>
        </div>
        <div class="form-item">
          <span class="form-label">{{ $t('personal.changePassword') }}：</span>
          <div>******</div>
          <i class="el-icon-edit ml0" @click="change" />
        </div>
        <div class="form-item">
          <span class="form-label">{{ $t('personal.validityPeriod') }}：</span>
          <div>2020-12-12</div>
        </div>
        <div class="form-item" v-if="$store.getters.cusId">
          <span class="form-label">{{ $t('personal.APIKey') }}：</span>
          <div v-if="userInfo.apiKey">{{ userInfo.apiKey }}</div>
          <div v-else><el-button type="primary" @click="getApiKey(userInfo.cusId)">{{ $t('personal.APIbtn') }}</el-button></div>
        </div>
      </div>
    </div>
    <!-- 修改密码弹出层 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="$t('personal.changePassword')" :visible.sync="passDialogVisible" width="420px" :before-close="handleClose">
      <el-row>
        <el-col :span="22">
          <el-form ref="passForm" :model="passForm" :rules="passRules">
            <el-form-item prop="originalPassword" :label="$t('personal.originalPassword')">
              <BjInput v-model="passForm.originalPassword" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('personal.originalPasswordText')" show-password />
            </el-form-item>
            <el-form-item prop="password" :label="$t('personal.newPassword')">
              <BjInput v-model="passForm.password" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('personal.newPasswordText')" show-password />
            </el-form-item>
            <el-form-item prop="checkPass" :label="$t('personal.checkPass')">
              <BjInput v-model="passForm.checkPass" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('personal.checkPassText')" show-password />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitPassForm('passForm')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <!-- 绑定手机号弹出层 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="$t('personal.mobileBinding')" :visible.sync="phoneDialogVisible" width="420px" :before-close="handleClose">
      <el-row>{{ $t('personal.none') }}</el-row>
    </el-dialog>
    <!-- 绑定邮箱弹出层 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="$t('personal.emailBinding')" :visible.sync="emailDialogVisible" width="420px" :before-close="handleClose">
      <el-row>{{ $t('personal.none') }}</el-row>
    </el-dialog>
    <!-- 校验密码弹出层 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="$t('personal.verifyPassword')" :visible.sync="checkDialogVisible" width="420px" :before-close="handleClose">
      <el-row>
        <el-col :span="22">
          <el-form ref="checkForm" :model="checkForm" :rules="checkRules">
            <el-form-item prop="pwd" :label="$t('personal.passwordValidation')">
              <BjInput v-model="checkForm.pwd" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('personal.enterPasswordText')" show-password />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitCheckForm('checkForm')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { userApi } from '@/api';
import { mapGetters } from 'vuex';
import BjUpload from '@/components/BjUpload/index';
import { validatePass } from '@/utils';

export default {
  components: {
    BjUpload,
  },
  filters: {
    phoneFilter(val) {
      if (val) {
        const reg = /^(.{3}).*(.{4})$/;
        return val.replace(reg, '$1****$2');
      }
    },
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('personal.passwordErrorMsg1')));
      } else if (value !== this.passForm.password) {
        callback(new Error(this.$t('personal.passwordErrorMsg2')));
      } else {
        callback();
      }
    };

    const validateEmail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      if (value === '') {
        callback(new Error(this.$t('personal.emailErrorMsg1')));
      } else {
        if (!reg.test(value)) {
          callback(new Error(this.$t('personal.passwordErrorMsg2')));
        } else {
          callback();
        }
      }
    };
    return {
      show: false,
      editName: '',
      // 1 绑定手机号、2 绑定邮箱
      type: '',
      sendCodeDisabled: false,
      sendCodeDisabledEmail: false,
      codeText: this.$t('personal.sendVerificationCode'),
      codeTextEmail: this.$t('personal.getVerificationCode'),
      passDialogVisible: false,
      phoneDialogVisible: false,
      emailDialogVisible: false,
      checkDialogVisible: false,
      passForm: {
        organizationId: null,
        originalPassword: null,
        password: null,
        checkPass: null,
      },
      passRules: {
        originalPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        checkPass: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
      phoneForm: {},
      phoneRules: {
        code: [
          { required: true, message: this.$t('personal.verificationCodeText'), trigger: 'blur' },
        ],
      },
      emailForm: {},
      emailRules: {
        email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        code: [
          { required: true, message: this.$t('personal.verificationCodeText'), trigger: 'blur' },
        ],
      },
      checkForm: {},
      checkRules: {
        pwd: [{ required: true, message: this.$t('personal.enterPasswordText'), trigger: 'blur' }],
      },
      lastCheckKey: null, // 前置-验证密码
      captchaKeyPhone: null, // 发送验证码后
      captchaKeyEmail: null, // 发送验证码后
    };
  },
  computed: {
    ...mapGetters(['avatar', 'name', 'userInfo']),
  },
  methods: {
    getApiKey(cusId){
      userApi.generateApiKey({cusId:cusId}).then(res=>{
        if(!res.failed){
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.$store.dispatch('user/getInfo');
        }
      })
    },
    showInput(name) {
      this.editName = name;
      this.show = true;
    },
    saveName() {
      this.show = false;
      this.updateMyRealName(this.editName);
    },
    concalName() {
      this.show = false;
    },
    change() {
      this.passDialogVisible = true;
    },
    showCheckDialog(type) {
      this.type = type;
      /** 清空密码校验输入框 */
      this.checkForm = {};
      this.checkDialogVisible = true;
    },
    submitPassForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        const API_DATA = this.$lodash.clone(this.passForm);
        delete API_DATA.checkPass;
        this.updateMyPassword(API_DATA);
      });
    },
    // 前置密码验证
    submitCheckForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.checkMyPassword(this.checkForm.pwd, () => {
          this.type === 1 ? (this.phoneDialogVisible = true) : (this.emailDialogVisible = true);
        });
      });
    },
    // 发送手机验证码
    sendCode() {
      const reg = /^1[0-9]{10}$/;
      if (!reg.test(this.phoneForm.phone) && this.phoneForm.phone != '') {
        this.$message.warning(this.$t('personal.phoneErrorMsg'));
      } else {
        this.sendCaptchaByPhone(this.phoneForm.phone, () => {
          let time = 60;
          const timePhone = setInterval(() => {
            if (time === 0) {
              clearInterval(timePhone);
              this.sendCodeDisabled = false;
              this.codeText = this.$t('personal.getVerificationCode');
            } else {
              time--;
              this.sendCodeDisabled = true;
              this.codeText = `${this.$t('personal.reacquire')}（' + time + '）`;
            }
          }, 1000);
        });
      }
    },
    // 发送邮箱验证码
    sendCodeEmail() {
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      if (!reg.test(this.emailForm.email) && this.emailForm.email != '') {
        this.$message.warning(this.$t('personal.emailErrorMsg2'));
      } else {
        this.sendCaptchaByEmail(this.emailForm.email, () => {
          let time = 60;
          const timerEmail = setInterval(() => {
            if (time === 0) {
              clearInterval(timerEmail);
              this.sendCodeDisabledEmail = false;
              this.codeTextEmail = this.$t('personal.getVerificationCode');
            } else {
              time--;
              this.sendCodeDisabledEmail = true;
              this.codeTextEmail = `${this.$t('personal.reacquire')}（' + time + '）`;
            }
          }, 1000);
        });
      }
    },
    // 验证手机
    submitPhoneForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.checkCaptchaByPhone(this.phoneForm.phone, this.phoneForm.code);
      });
    },
    // 验证邮箱
    submitEmailForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.checkCaptchaByEmail(this.emailForm.email, this.emailForm.code);
      });
    },

    handleClose(done) {
      this.passDialogVisible = false;
      this.phoneDialogVisible = false;
      this.emailDialogVisible = false;
      this.checkDialogVisible = false;
    },
    afterUpload(res) {
      this.updateMyAvatar(res);
    },
    /** 上传图片操作 */
    // handleAvatarSuccess(res, file) {
    //   // this.avatar = res.data.url;
    //   // TODO:  图片变链接
    //   this.updateMyAvatar(
    //     'http://dp.gtimg.cn/discuzpic/0/discuz_x5_gamebbs_qq_com_forum_201306_19_1249187cz567ahchxxns6x.jpg/0',
    //   );
    // },
    beforeAvatarUpload(file) {
      const isJPGOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 0.5;

      if (!isJPGOrPng) {
        this.$message.error(this.$t('personal.avatarErrorMsg1'));
      }
      if (!isLt2M) {
        this.$message.error(this.$t('personal.avatarErrorMsg2'));
      }
      return isJPGOrPng && isLt2M;
    },
    /** ******* API *********** */
    updateMyRealName(realName) {
      const API_DATA = { realName: realName };
      userApi.updateMyRealName(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.$store.dispatch('user/getInfo');
        }
      });
    },
    updateMyPassword(API_DATA) {
      userApi.updateMyPassword(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.handleClose();
          this.$store.dispatch('user/getInfo');
        }
      });
    },
    checkMyPassword(password, fun) {
      const API_DATA = { password: password };
      userApi
        .checkMyPassword(API_DATA)
        .then(res => {
          if (res.lastCheckKey) {
            this.lastCheckKey = res.lastCheckKey;
            fun();
          } else {
            this.lastCheckKey = null;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {
          this.lastCheckKey = null;
        });
    },
    sendCaptchaByPhone(phone, fun) {
      const API_DATA = { lastCheckKey: this.lastCheckKey, phone: phone };
      userApi.sendCaptchaByPhone(API_DATA).then(res => {
        if (
          res.id ||
          res._token ||
          res.content ||
          Array.isArray(res) ||
          res.failed === false ||
          (res.message && res.message.includes(this.$t('personal.hasBeenSent')))
        ) {
          this.captchaKeyPhone = res.captchaKey || null;
          this.$message.success(res.message || this.$t('personal.sendSuccess'));
          fun();
        }
      });
    },
    sendCaptchaByEmail(email, fun) {
      const API_DATA = { lastCheckKey: this.lastCheckKey, email: email };
      userApi.sendCaptchaByEmail(API_DATA).then(res => {
        if (
          res.id ||
          res._token ||
          res.content ||
          Array.isArray(res) ||
          res.failed === false ||
          (res.message && res.message.includes(this.$t('personal.hasBeenSent')))
        ) {
          this.captchaKeyEmail = res.captchaKey || null;
          this.$message.success(res.message || this.$t('personal.sendSuccess'));
          fun();
        }
      });
    },
    checkCaptchaByPhone(phone, captcha) {
      const API_DATA = {
        lastCheckKey: this.lastCheckKey, // 前置密码校验返回的
        captchaKey: this.captchaKeyPhone, // 给新手机号发送验证码返回的
        captcha: captcha,
        phone: phone,
      };
      userApi.checkCaptchaByPhone(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.handleClose();
          this.$store.dispatch('user/getInfo');
        }
      });
    },
    checkCaptchaByEmail(email, captcha) {
      const API_DATA = {
        lastCheckKey: this.lastCheckKey, // 前置密码校验返回的
        captchaKey: this.captchaKeyEmail, // 给新邮箱发送验证码返回的
        captcha: captcha,
        email: email,
      };
      userApi.checkCaptchaByEmail(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.handleClose();
          this.$store.dispatch('user/getInfo');
        }
      });
    },
    updateMyAvatar(avatar) {
      const API_DATA = { avatar: avatar };
      userApi.updateMyAvatar(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.handleClose();
          this.$store.dispatch('user/getInfo');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  margin-top: 30px;

  .picture{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .avatar {
      width: 80px !important;
      height: 80px !important;
      border-radius: 50%;
   }
  }
}
.form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
  margin-left: 100px;
  .form-item {
    display: flex;
    align-items: center;
    .form-label {
      display: inline-block;
      width: 140px;
    }
    .m20 {
      cursor: pointer;
    }
  }
}
.form .el-input {
  height: 26px;
  line-height: 26px;
  width: 160px;
}
</style>
